module.exports = __webpack_public_path__ + "static/media/everyday_digital_and_weekend_papers_cropped.c1245c2d.png";